const EVENT_NAMES = new Set([
  "shell_exposed",
  "destination_opened",
  "context_opened",
  "context_closed",
  "task_terminal",
  "reuse_invoked",
]);

const FLAG_NAMES = [
  "chat",
  "execution",
  "objectives",
  "approvals",
  "attention",
  "destinations",
  "reusableResults",
];
const DESTINATIONS = new Set(["command", "operations", "library", "connections"]);
const TERMINAL_PHASES = new Set(["completed", "failed", "stopped"]);
const MARK_PREFIX = "optimus.command_center.";
const MAX_MARKS = 100;

export function sanitizeCommandCenterDiagnostic(eventName, detail = {}) {
  if (!EVENT_NAMES.has(eventName)) return null;
  const safe = {};
  if (eventName === "shell_exposed") {
    FLAG_NAMES.forEach((name) => {
      safe[name] = detail[name] === true;
    });
  }
  if (eventName === "destination_opened" && DESTINATIONS.has(detail.destination)) {
    safe.destination = detail.destination;
  } else if (eventName === "destination_opened") {
    return null;
  }
  if (eventName === "task_terminal" && TERMINAL_PHASES.has(detail.phase)) {
    safe.phase = detail.phase;
  } else if (eventName === "task_terminal") {
    return null;
  }
  return { eventName, detail: safe };
}

export function recordCommandCenterDiagnostic(
  eventName,
  detail,
  performanceApi = typeof window !== "undefined" ? window.performance : null,
) {
  const diagnostic = sanitizeCommandCenterDiagnostic(eventName, detail);
  if (!diagnostic || typeof performanceApi?.mark !== "function") return false;
  try {
    const marks = typeof performanceApi.getEntriesByType === "function"
      ? performanceApi.getEntriesByType("mark").filter((entry) =>
          entry.name.startsWith(MARK_PREFIX))
      : [];
    if (marks.length >= MAX_MARKS) {
      if (typeof performanceApi.clearMarks !== "function") return false;
      let remainingCount = marks.length;
      const clearedNames = new Set();
      const countsByName = marks.reduce((counts, mark) => {
        counts.set(mark.name, (counts.get(mark.name) || 0) + 1);
        return counts;
      }, new Map());
      for (const mark of marks) {
        if (remainingCount < MAX_MARKS) break;
        if (clearedNames.has(mark.name)) continue;
        clearedNames.add(mark.name);
        performanceApi.clearMarks(mark.name);
        remainingCount -= countsByName.get(mark.name) || 0;
      }
      if (remainingCount >= MAX_MARKS) return false;
    }
    performanceApi.mark(`${MARK_PREFIX}${diagnostic.eventName}`, {
      detail: diagnostic.detail,
    });
    return true;
  } catch (_error) {
    return false;
  }
}

export const COMMAND_CENTER_DIAGNOSTIC_LIMIT = MAX_MARKS;
